import React from 'react';
import { CreateContractInput } from '../../types/contract';
import { ContractForm } from '../Contracts/ContractForm';
import { X } from 'lucide-react';

interface CreateContractModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (data: CreateContractInput, isDraft?: boolean) => void;
    initialData?: Partial<CreateContractInput>;
    isSubmitting?: boolean;
    mode?: 'create' | 'edit';
}

export const CreateContractModal: React.FC<CreateContractModalProps> = ({
    isOpen,
    onClose,
    onSubmit,
    initialData,
    isSubmitting,
    mode = 'create'
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
            <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
            <div className="relative bg-white rounded-2xl shadow-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto animate-scale-in">
                <div className="p-6 border-b border-gray-100 flex items-center justify-between sticky top-0 bg-white z-10">
                    <h3 className="text-xl font-bold text-gray-900">
                        {mode === 'create' ? '发起合同' : '编辑合同'}
                    </h3>
                    <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full">
                        <X className="w-5 h-5 text-gray-500" />
                    </button>
                </div>

                <div className="p-8">
                    <ContractForm
                        initialData={initialData}
                        onSubmit={onSubmit}
                        onCancel={onClose}
                        isSubmitting={isSubmitting}
                    />
                </div>
            </div>
        </div>
    );
};
